import * as Yup from 'yup';
import { AlertsProcess } from '../../../../../../shared/types/legalProceedings/alerts';

export const initialValues: AlertsProcess = {
    receptionChannel: '',
    typePQR: '',
    receivedThrough: '',
    subtypeDP: '',
    transaction: '',
};

export const validationSchema = () =>
    Yup.object({
        receptionChannel: Yup.string().required(
            'El canal de recepción es obligatorio'
        ),
        typePQR: Yup.string().required('El tipo PQR es obligatorio'),
        receivedThrough: Yup.string().required('El medio es obligatorio'),
        subtypeDP: Yup.string().required('El subtipo DP es obligatorio'),
        transaction: Yup.string().required('El tramite es obligatorio'),
    });
